export default "__VITE_ASSET__dc0ac567__"